<script setup lang="ts">
import CarouselMobile from '../../../CarouselMobile/CarouselMobile.vue';
import IMG_MSG_INTERACTION from '../../assets/msg-interaction.png';
import IMG_STEP_INTERACTION from '../../assets/step-interaction.png';

interface Props {
  backgroundImage: string;
  productImage?: string;
  isMsgShow?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  productImage: '',
  isMsgShow: true
});
</script>

<template>
<div class="interaction">
  <CarouselMobile
    :mobileFrameImage="IMG_STEP_INTERACTION"
    :backgroundImage="props.backgroundImage"
    :productImage="props.productImage"
    :msgImage="IMG_MSG_INTERACTION"
    :isMsgShow="props.isMsgShow"
    :isShowHeaderInfo="true"
  />
</div>
</template>
